// extracted by mini-css-extract-plugin
export default {"bottomButtons":"ClientVariablesPage_bottomButtons__iZd0E","spinner":"ClientVariablesPage_spinner__6dfFX"};